import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// ScrollToTop component to handle automatic scrolling on route changes
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Small delay to ensure the route has fully changed
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 50);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
